<template>
  <div class="card-document-annexes">
    <BaseIcon v-if="isDesktop" type="scarf-pin" />
    <div class="card-document__trigger" v-else>
      <BaseIcon type="scarf-pin" />
      <a class="card-document-annexes__trigger" href="javascript:void(0);" v-if="!isDesktop" @click.prevent.stop="handleClick">
        {{ $t('message.common.documents.annexes') }}
      </a>
    </div>
    <ul class="card-document-annexes__list" v-show="showList">
      <CardDocumentAnnex
        v-for="(item, index) in annexes"
        tag="li"
        :key="`annex-${index + 1}`"
        :index="index"
        :url="item.url"
        :name="item.name" />
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseIcon from '@base/BaseIcon'
import CardDocumentAnnex from './CardDocumentAnnex'
export default {
  name: 'CardDocumentAnnexes',
  props: {
    annexes: {
      type: Array,
      required: true
    }
  },
  components: {
    BaseIcon,
    CardDocumentAnnex
  },
  data () {
    return {
      showList: false
    }
  },
  computed: {
    ...mapGetters({
      device: 'breakpoints/getDevice'
    }),
    isDesktop () {
      return this.device === 'desktop'
    }
  },
  watch: {
    device () {
      this.updateShowList()
    }
  },
  created () {
    this.updateShowList()
  },
  methods: {
    updateShowList () {
      this.showList = this.device === 'desktop'
    },
    handleClick () {
      this.showList = !this.showList
    }
  }
}
</script>

<style lang="scss">
  .card-document-annexes{
    @include media("small-medium"){
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
    }
    @include media("large"){
      flex-direction: row;
      justify-content: flex-start;
      align-items: baseline;
    }

    display: flex;

    // Trigger

    &__trigger{
      flex: 0 0 auto;
      display: inline-flex;
      padding-bottom: layout("spacing")/2;
    }

    // List

    &__list{
      $additional-width: 10rem;
      $mobile-width: calc(100% + 11rem);

      @include no-type-list;
      @include media("small-medium"){
        padding-top: layout("spacing")/2;
        box-shadow: 0rem 1rem 1rem -.5rem rgba(black, 0.1) inset;
        width: $mobile-width;
        flex: 1 1 auto;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        margin-left: -10rem;
      }

      @include media("large"){
        display: inline-flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        flex: 0 1 auto;
      }

      li{
        @include media("small-medium"){
          width: 100%;
          padding: layout("spacing")/2 layout("spacing");
          word-wrap: break-word;
          flex: 0 1 auto;
          &:not(:last-of-type){
            border-bottom: 1px solid shade(colors("foreground"), 10%);
          }
        }
        @include media("large"){
          &:not(:last-of-type){
            &::after{
              content: ',';
              margin-right: 3px;
            }
          }
        }

        position: relative;
        flex: 0 1 auto;
      }

      a{
        @include text-color(colors("font"), colors("primary"));
      }
    }

    .icon{
      margin-right: layout("spacing")/2;
    }
  }
</style>
